<!-- Иконка загрузки использует DownloadIcon со стрелкой вверх и общей нижней полкой. -->
<template>
  <DownloadIcon
    :size="size"
    :stroke="stroke"
    direction="up"
  />
</template>

<script>
import DownloadIcon from "@/components/Icon/icons/DownloadIcon.vue";

export default {
  name: "UploadIcon",

  components: {
    DownloadIcon,
  },

  props: {
    size: {
      type: [Number, String],
      default: 20,
    },
    stroke: {
      type: String,
      default: "currentColor",
    },
  },
};
</script>
